import styled from "@emotion/styled";
import BaseButton from "./BaseButton";
import { darken } from "@material-ui/core/styles/colorManipulator";

export default styled("button")`
    ${BaseButton};
    background: #f8f8f8;
    color: #4a4a4a;

    :hover {
        background: ${darken("#f8f8f8", 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${darken("#f8f8f8", 0.25)};
    }

    border: 1px solid #d7d7d7; /* stylelint-disable-line */
    border-radius: 2px;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: normal;
    line-height: normal;
    padding: 8px 32px !important;
    text-transform: none;
`;
